module.exports = __webpack_public_path__ + "static/media/work-details-btn.202992be.PNG";